function mergeEvents(items, rates) {
    // Server order preserves restricted boundaries and whole visits. Rates must not reorder visits across gaps.
    const result = items.slice();
    (rates || []).slice().sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) || String(b.id).localeCompare(String(a.id))).forEach(rate => {
        let index = result.findIndex(item => item.kind !== 'restricted' && !(item.kind === 'visit' && item.current)
            && String(item.date || '') < String(rate.date || ''));
        if (index < 0) index = result.length;
        if (index > 0 && result[index - 1].kind === 'restricted') index--;
        result.splice(index, 0, rate);
    });
    return result;
}

function assessmentPreview(item) {
    if (item.preview !== undefined) return item.preview;
    return item.text || (item.fields || []).filter(field => !['Да', 'Нет'].includes(field.value)).map(field => field.value).find(Boolean) || '';
}
function formatDate(value) { return value ? String(value).split('-').reverse().join('.') : ''; }
function formatMonth(value) { return value ? new Date(`${value}-01T12:00:00`).toLocaleDateString('ru-RU', {month: 'long', year: 'numeric'}) : 'Месяц неизвестен'; }
function hours(value) { return value === null || value === undefined ? 'Часы неизвестны' : `${Math.floor(value / 60)} ч${value % 60 ? ` ${Math.round(value % 60)} мин` : ''}`; }

function calendarDuration(startDate, days) {
    if (!Number.isInteger(days) || days < 0) return '';
    const fallback = `${days} кал. дн.`;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(startDate || '')) return fallback;
    const start = new Date(`${startDate}T00:00:00Z`);
    if (!Number.isFinite(start.getTime()) || start.toISOString().slice(0, 10) !== startDate) return fallback;
    // Keep the server's inclusive calendar-day count, independent of today's date and DST.
    const end = new Date(start.getTime() + days * 86400000);
    const atMonth = count => {
        const result = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + count, 1));
        const lastDay = new Date(Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)).getUTCDate();
        result.setUTCDate(Math.min(start.getUTCDate(), lastDay));
        return result;
    };
    let months = (end.getUTCFullYear() - start.getUTCFullYear()) * 12 + end.getUTCMonth() - start.getUTCMonth();
    if (atMonth(months) > end) months--;
    if (months < 1) return fallback;
    const years = Math.floor(months / 12);
    const remainder = Math.round((end - atMonth(months)) / 86400000);
    const yearLabel = years % 100 >= 11 && years % 100 <= 14 ? 'лет' : years % 10 === 1 ? 'год' : years % 10 >= 2 && years % 10 <= 4 ? 'года' : 'лет';
    return [years ? `${years} ${yearLabel}` : '', months % 12 ? `${months % 12} мес.` : '', remainder ? `${remainder} дн.` : ''].filter(Boolean).join(' ');
}

function isCurrentAssignment(item) {
    return item.kind === 'visit' && item.mode === 'assignment' && item.current;
}
function planState(item) {
    return {confirmed: 'Прибытие подтверждено', baseline: 'Присутствие принято по табелям',
        unconfirmed: item.matches_assignment ? 'Назначение уже есть; подтверждение прибытия не оформлено' : 'Прибытие не подтверждено',
        unknown: 'Не удалось проверить подтверждение прибытия. Обновите путь сотрудника.'}[item.arrival_state] || '';
}
module.exports = {mergeEvents, assessmentPreview, formatDate, formatMonth, hours, calendarDuration, isCurrentAssignment, planState};
